module.exports = __webpack_public_path__ + "media/photo/it_managebg-045ee450.jpg";